import React, { useState } from "react"

import { useEvent } from "shared/lib/useEvent"
import { SHOW_ACCESSIBILITY_MESSAGE } from "shared/types/AppEvent"

import { useAppEventSubscription } from "app/useAppEventSubscription"

export interface AccessibilityMessage {
  id: string
  text?: string
}

export const AccessibilityInfo = React.memo(() => {
  const [messages, setMessages] = useState<AccessibilityMessage[]>([])

  const handleAccessibilityMessage = useEvent(
    ({
      messages: nextMessages
    }: {
      messages?: AccessibilityMessage | AccessibilityMessage[] | null
    }) => {
      if (Array.isArray(nextMessages)) {
        setMessages(nextMessages)
      } else if (nextMessages) {
        setMessages([nextMessages])
      } else {
        setMessages([])
      }
    }
  )

  useAppEventSubscription({
    eventType: SHOW_ACCESSIBILITY_MESSAGE,
    handler: handleAccessibilityMessage
  })

  return (
    <span
      aria-live="polite"
      aria-atomic={false}
      aria-relevant="additions text"
      className="visually-hidden"
    >
      {messages?.map(message => (
        <span id={message.id} key={message.id}>
          {message.text}
        </span>
      ))}
    </span>
  )
})
